import {connect} from 'react-redux'

import {EmailChangeVerification} from './EmailChangeVerification'
import {AppDispatch} from 'Store'
import {RootState} from 'Store/Reducers'
import {getUser, hideEmailResentMessage, verifyChangeEmail} from 'Store/Actions'

const mapStateToProps = (state: RootState) => ({
  emailChangeVerify: state.auth.emailChangeVerify,
  isEmailResent: state.auth.displayMessage.resendEmailVerification,
  auth: state.auth,
})

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getUser: () => dispatch(getUser()),
  hideEmailResentMessage: () => dispatch(hideEmailResentMessage()),
  verifyChangeEmail: (token: string) => dispatch(verifyChangeEmail(token)),
})

export const EmailChangeVerificationContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailChangeVerification)
